// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  signId: __t.u64().primaryKey().name("sign_id"),
  identity: __t.identity(),
  kind: __t.string(),
  settlementId: __t.u64().name("settlement_id"),
  refId: __t.u64().name("ref_id"),
  detail: __t.string(),
  at: __t.timestamp(),
});
